/**
 * /dashboard/performance/goals/$id — Goal detail (Phase 7.3a).
 *
 * Uses the single-GET endpoint GET /performance/goals/{id}.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/performance/goals/[id]/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - use(params) → Route.useParams()
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { GoalDetail } from "@/components/performance/goal-detail";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/goals/$id",
)({
  component: GoalDetailRoute,
});

function GoalDetailRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  const { id } = Route.useParams();
  const numId = Number(id);

  return (
    <PerformanceModuleShell
      title="Goal"
      description="Objective progress, key results and check-ins."
      actions={
        <Button asChild variant="outline" className="gap-1.5">
          <Link to="/app/$tenantSlug/performance/goals" params={{ tenantSlug }}>
            <ArrowLeft className="h-4 w-4" />
            Back to goals
          </Link>
        </Button>
      }
    >
      <PerformanceFeatureGate>
        {Number.isFinite(numId) && numId > 0 ? (
          <GoalDetail goalId={numId} />
        ) : (
          <p className="text-sm text-muted-foreground">
            Invalid goal id.
          </p>
        )}
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
